/* A 48px square, above the 44px touch minimum, in the accent with the hard
 * button shadow; pressed open it turns ink and drops the shadow, so the open
 * state reads at a glance. */
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  padding: 0;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
  cursor: pointer;
}

.button[aria-expanded='true'] {
  background: var(--ink);
  color: var(--bg);
  box-shadow: none;
}

@media (min-width: 720px) {
  .button {
    display: none;
  }
}

/* The glyphs are masks painted in currentColor, so they follow the button's
 * colour in both states and in dark mode. */
.menu,
.close {
  width: 22px;
  height: 22px;
  background-color: currentColor;
}

.menu {
  -webkit-mask: url('./menu.svg') no-repeat center / contain;
  mask: url('./menu.svg') no-repeat center / contain;
}

.close {
  -webkit-mask: url('./close.svg') no-repeat center / contain;
  mask: url('./close.svg') no-repeat center / contain;
}
